import styles from './HbxAutoInvoice.styles.js';
import useHbxAutoInvoiceHook from './HbxAutoInvoice.hook.js';
import React, { useContext } from 'react';
import InfoPill from '../../../common/InfoPill/InfoPill';
import BaseTable from '../../../common/BaseTable/BaseTable';
import CustomButton from '../../../common/CustomButton/CustomButton';
import Colors from '../../../../constants/Colors';
import DefaultLayout from 'Components/DefaultLayout/DefaultLayout.jsx';
import { AppContext } from 'App.context.js';
import RequestSuscription from '../../../common/RequestSuscription/RequestSuscription.jsx';
import Modal from 'antd/lib/modal/Modal';
import AdviceDisableProduct from '../AdviceDisableProduct/AdviceDisableProduct.jsx';
import hbxConstants from '../hbxConstants.js';
import ContentBox from 'Components/common/ContentBox/ContentBox.jsx';
import AppSelector from 'Components/common/AppSelector/AppSelector';
import { EditOutlined } from '@ant-design/icons';
import InvoiceS3 from './Platforms/InvoiceS3/InvoiceS3.jsx';
import InvoiceAPI from './Platforms/InvoiceAPI/InvoiceAPI.jsx';
import InvoiceSFTP from './Platforms/InvoiceSFTP/InvoiceSFTP.jsx';

export default function HbxAutoInvoice() {
  const {
    appActions: { translate },
  } = useContext(AppContext);
  const { state, actions } = useHbxAutoInvoiceHook();

  const columns = [
    {
      title: translate('salesChannels.stateCol'),
      key: 'state',
      dataIndex: 'state',
      align: 'center',
      width: '12%',
      render: () => {
        return (
          <div>
            {actions.getStateTextColor() == Colors.greenHotelIntegratedBg ? (
              <InfoPill
                backgroundColor={actions.getStateBackgroundColor()}
                color={actions.getStateTextColor()}
                text={actions.getStateString()}
              />
            ) : (
              <InfoPill
                color={actions.getStateTextColor()}
                backgroundColor={actions.getStateBackgroundColor()}
                text={actions.getStateString()}
              />
            )}
          </div>
        );
      },
    },
    {
      title: translate('salesChannels.hotelCol'),
      dataIndex: 'hotel',
      key: 'hotel',
      align: 'center',
      width: '25%',
      render: (_, row) => {
        return <div style={{ fontWeight: 500 }}>{row.hotel}</div>;
      },
    },
    {
      title: translate('salesChannels.actionCol'),
      key: 'key',
      dataIndex: 'key',
      align: 'center',
      width: '20%',
      render: (_, record) => <div>{renderActionCol(state, actions, translate, record)}</div>,
    },
  ];

  const renderPlatform = () => {
    switch (state.selectedOptionConnection) {
      case 'SFTP':
        return <InvoiceSFTP />;
      case 'API':
        return <InvoiceAPI pmsNotPermit={state.pmsNotPermit} />;
      case 'S3':
        return <InvoiceS3 />;
      default:
        return null;
    }
  };

  return (
    <DefaultLayout singleBox>
      {state.suscription ? (
        <div>
          <div style={styles.tableContainer}>
            <div style={styles.table}>
              <BaseTable
                columns={columns}
                data={state.dataSource}
                loading={state.isLoading}
                notShowPagination={true}
                localPagination
                expandable={{
                  expandedRowKeys: [state.expandedRow],
                  onExpand: record => {
                    actions.onExpanded(record.id);
                  },
                  expandIconColumnIndex: -1,
                  expandedRowRender: record => (
                    <div>
                      <ContentBox
                        title={translate('policeReport.connectionType')}
                        customMinSize={18}
                      >
                        <AppSelector
                          title={translate('policeReport.chooseConnectionType')}
                          value={state.selectedOptionConnection}
                          options={state.connectionOptions}
                          onOptionSelected={actions.handleSelectConnection}
                        />
                        {renderPlatform()}
                      </ContentBox>
                    </div>
                  ),
                }}
              />
            </div>
          </div>
        </div>
      ) : (
        <RequestSuscription suscription="hbx_invoicing" />
      )}
    </DefaultLayout>
  );
}

function renderActionCol(state, actions, translate, record) {
  const buttonStyleDisable = {
    minWidth: 350,
    backgroundColor: Colors.disabledButton,
    color: 'white',
  };
  const buttonStyleActive = {
    minWidth: 350,
    backgroundColor: Colors.bookingColorCheckinList,
    color: 'white',
  };
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        padding: '0 16px',
      }}
    >
      <ExpandIcon
        bg={Colors.blueBoxColor}
        onClick={(r, e) => actions.onExpanded(record.id)}
        record={record}
        color={Colors.grayText}
      />
      {state.isActive ? (
        <div>
          <CustomButton
            background={Colors.disabledButton}
            color={'white'}
            text={translate('hbxProducts.disableButton')}
            onClick={() => actions.setAdviceDisableProduct(true)}
            style={buttonStyleDisable}
          />
          <Modal
            title={translate('hbxProducts.adviceDisableProduct')}
            open={state.AdviceDisableProduct}
            onCancel={() => actions.setAdviceDisableProduct(false)}
            cancelText={translate('hbxProducts.cancel')}
            onOk={() => {
              actions.setAdviceDisableProduct(false);
              actions.changeOTAState(false);
            }}
            okText={translate('hbxProducts.disable')}
            okType={'danger'}
          >
            <AdviceDisableProduct
              setShowModal={actions.setAdviceDisableProduct}
              product="Invoice Automation"
            />
          </Modal>
        </div>
      ) : (
        <CustomButton
          background={Colors.bookingColorCheckinList}
          color={'white'}
          text={translate('hbxProducts.enableButton')}
          onClick={() => actions.changeOTAState(true)}
          style={buttonStyleActive}
        />
      )}
    </div>
  );
}

function ExpandIcon({ bg, onClick, record, color }) {
  return (
    <div
      style={{
        height: 36,
        width: 36,
        backgroundColor: bg,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 8,
        boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
      }}
      onClick={event => onClick(record, event)}
    >
      <EditOutlined style={{ color }} />
    </div>
  );
}
